var map = {
	"./ACT.svg": "W8B4",
	"./NSW.svg": "9Z7I",
	"./NT.svg": "rgvI",
	"./QLD.svg": "gt9E",
	"./SA.svg": "J0Vz",
	"./TAS.svg": "M6ZQ",
	"./VIC.svg": "IIB4",
	"./WA.svg": "8rxK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MGww";